import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import './global.less';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';
// @ts-ignore
import { PersistGate } from 'redux-persist/integration/react';
import packageJson from '../package.json';
import reportWebVitals from './reportWebVitals';
import { store, persistor } from './redux/config';
import AppRoute from './routes/AppRoute';
import { Data, Setup } from './init/index';
import LoadingContainer from './ui/components/LoadingScreen/LoadingContainer';
import Notification from './ui/components/Notification/Notification';
import Dialog from './ui/components/Dialog/Dialog';
import Subscriber from './init/Subscriber';
import StatusIndicator from './ui/components/StatusIndicator/StatusIndicator';
import ErrorBoundary from './ui/components/ErrorBoundary/ErrorBoundary';
import MapContainer from './ui/pages/Map/MapContainer';
import { isMobileBrowser } from './utils';
import {
  isBND,
  isCTF,
  isFRM,
  isMVV,
  isKYCApp,
  isTLA,
  isGRF,
  isOSN,
  isSCT,
  isBUB,
} from 'getaway-data-layer';
import 'antd/dist/reset.css';

const isWidgetMode = (() => {
  try {
    const params = new URLSearchParams(window.location.search);
    return params.get('mode') === 'widget';
  } catch {
    return false;
  }
})();

const sentryEnvironment = isWidgetMode
  ? 'widget'
  : process.env.VITE_STAGE === 'production'
  ? 'production'
  : 'staging';

Sentry.init({
  dsn: process.env.VITE_SENTRY_DSN,
  tracesSampleRate: 0.2,
  release: packageJson.version,
  environment: sentryEnvironment,
  ignoreErrors: [
    'TypeError: Load failed',
    'URI error',
    'URI sequence',
    'URI malformed',
  ],
});

const rootElement = document.getElementById('root');
if (rootElement) {
  let root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );

  root.render(
    <React.Fragment>
      <Provider store={store}>
        <PersistGate loading={<LoadingContainer />} persistor={persistor}>
          <ErrorBoundary>
            <Setup>
              <Subscriber>
                <Data>
                  <>
                    <StatusIndicator />
                    <Notification />
                    {isMobileBrowser() || isKYCApp() ? (
                      <div
                        className={
                          !isMobileBrowser()
                            ? isBND()
                              ? 'bnd-desktop-bg'
                              : isFRM()
                              ? 'frm-desktop-bg'
                              : isMVV()
                              ? 'mvv-desktop-bg'
                              : isTLA()
                              ? 'tla-desktop-bg'
                              : isCTF()
                              ? 'ctf-desktop-bg'
                              : isGRF()
                              ? 'grf-desktop-bg'
                              : isOSN()
                              ? 'osn-desktop-bg'
                              : isSCT()
                              ? 'sct-desktop-bg'
                              : isBUB()
                              ? 'bub-desktop-bg'
                              : 'sps-desktop-bg'
                            : ''
                        }
                      >
                        <Router>
                          <AppRoute />
                          <Dialog />
                        </Router>
                      </div>
                    ) : (
                      <Router>
                        <div style={{ display: 'flex' }}>
                          <AppRoute />
                          <div
                            style={{
                              position: 'relative',
                              height: '100%',
                              width: 'calc(100%)',
                            }}
                          >
                            <MapContainer />
                          </div>
                        </div>
                        <Dialog />
                      </Router>
                    )}
                  </>
                </Data>
              </Subscriber>
            </Setup>
          </ErrorBoundary>
        </PersistGate>
      </Provider>
    </React.Fragment>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
